import externalSlugify from 'slugify';

export function slugify(text: string): string {
    return externalSlugify(text, { lower: true, strict: true });
}
